/** Matches super-admin list UIs: `session_code` or `SIM-{id}` when unset. */
export function pdSessionListDisplayCode(session: { id: number; session_code?: string | null }): string {
  const code = (session.session_code ?? '').trim();
  return code || `SIM-${session.id}`;
}

/** True for control-plane simulate sessions; false for tenant UUID session codes. */
export function isSuperAdminSimulatePdSession(session: { id: number; session_code?: string | null }): boolean {
  return pdSessionListDisplayCode(session).includes('SIM');
}
